
      
      <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="grid-row">
        <div nz-col [nzSpan]="18" [nzPull]="18" [nzPush]="3">
          <!-- </div> -->
          <div nz-col class="custom-ant-col" style="height: 120px;padding:50px;text-align: left;font-weight: bold;background: white;font-size: 20px;line-height: 36px;background: white;">
            Sorry! We don't find your access to this page. Please check for below points:<br>
            
          <p></p>
          </div>
          <ul>
            <li>1. Your profile might not be exists in Law Function Directory.</li>
            <li>2. You are not authorized to access this page.</li>              
          </ul>
          <br>
          Please make sure your profile exist in Law Function Directory.
        </div>
      </div>

